import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    createStyles,
    Button,
    Collapse,
    Textarea,
    FileInput,
    Text,
    Image,
    FileButton
} from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';

import { CarCreationCardBComp } from '../components/CarCreationCardBComp';



const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));

//needed:this needs params
export function CarCreationCardB() {
    const [sectionBOpen, setSectionBOpened] = useState(false);
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'articleSection_6',
    }
    
    //later:turn this into an api call
    const sectionDets = [
        {
            placeHolder: "A brief overview of the listing",
            itemLabel: "Brief Description",
            itemName: "brief_descript_0",
            galleryName: "brief_descript_gallery_2_3",
        },
        {
            placeHolder: "An introduction to the auction listing",
            itemLabel: "Introduction",
            itemName: "introduction_0",
            galleryName: "introduction_gallery_2_3",
        },
        {
            placeHolder: "Describe any notable details about the listings powertrain",
            itemLabel: "Powertrain",
            itemName: "power_train_0",
            galleryName: "power_train_gallery_2_3",
        },
        {
            placeHolder: "Describe any notable details about the exterior (upgrades, scratches, blemishes, etc)",
            itemLabel: "Exterior",
            itemName: "exterior_0",
            galleryName: "exterior_gallery_2_3",
        },
        {
            placeHolder: "Describe any notable details about the interior (upgrades, leather, cloth, etc)",
            itemLabel: "Interior",
            itemName: "interior_0",
            galleryName: "interior_gallery_2_3",
        },
        {
            placeHolder: "Describe any notable details about the chassis (upgrades, maintentance, alterations, etc)",
            itemLabel: "Chassis",
            itemName: "chassis_0",
            galleryName: "chassis_gallery_2_3",
        },
        {
            placeHolder: "Describe any documentation that is included for the car",
            itemLabel: "Docs",
            itemName: "docs_0",
            galleryName: "docs_gallery_2_3",
        },
    ];
    const sectionItems = sectionDets.map((item, index) =>
        <CarCreationCardBComp
            key={nanoid()}
            placeHolder={item.placeHolder}
            itemLabel={item.itemLabel}
            itemName={item.itemName}
            galleryName={item.galleryName}
        />
    )
    

    
    //needed:make a call to the db
    //needed:city and states in ref db
    //needed:custom image and card as the select model
    //needed:event list w/parallel handlers and error handling(ref text input contolled)

    return (
        <>
            {sectionItems}
        </>
    );
}
